import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("email")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("password")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Password ")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_textfield_icon = _resolveComponent("ui-textfield-icon")!
  const _component_ui_textfield = _resolveComponent("ui-textfield")!
  const _component_ui_form_field = _resolveComponent("ui-form-field")!
  const _component_ui_alert = _resolveComponent("ui-alert")!
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_grid = _resolveComponent("ui-grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_grid, null, {
      default: _withCtx(() => [
        _createVNode(_component_ui_grid_cell, { columns: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_form, { "item-margin-bottom": "20" }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_form_field, { class: "form-item" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_textfield, {
                      fullwidth: "",
                      outlined: "",
                      "with-leading-icon": "",
                      modelValue: _ctx.v$.formData.$model.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.formData.$model.email) = $event)),
                      modelModifiers: { trim: true }
                    }, {
                      before: _withCtx(() => [
                        _createVNode(_component_ui_textfield_icon, null, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ui_form_field, { class: "form-item" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_textfield, {
                      fullwidth: "",
                      outlined: "",
                      "with-leading-icon": "",
                      modelValue: _ctx.v$.formData.$model.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.formData.$model.password) = $event)),
                      modelModifiers: { trim: true },
                      "input-type": "password"
                    }, {
                      before: _withCtx(() => [
                        _createVNode(_component_ui_textfield_icon, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.v$.formData.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.formData.$silentErrors, (error, i) => {
                        return (_openBlock(), _createBlock(_component_ui_alert, {
                          state: "error",
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ui_form_field, { class: "form-item form-actions" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_button, {
                      disabled: _ctx.isDisabled,
                      class: _normalizeClass(['full-width']),
                      raised: "",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.getAuthError)
              ? (_openBlock(), _createBlock(_component_ui_alert, {
                  key: 0,
                  state: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getAuthError.message), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}